/**
 * Created by RoryHe on 2020/7/7.
 * 工具类
 */
import validConst from '@/assets/js/validate'
/**
 * 获取字符串的哈希值
 * @param {String} str
 * @param {Boolean} caseSensitive
 * @return {Number} hashCode
 */
export const hash = (str, caseSensitive) => {
  if (!caseSensitive) {
    str = str.toLowerCase();
  }
  // 1315423911=b'1001110011001111100011010100111'
  var hash = 1315423911, i, ch;
  for (i = str.length - 1; i >= 0; i--) {
    ch = str.charCodeAt(i);
    hash ^= ((hash << 5) + ch + (hash >> 2));
  }
  return (hash & 0x7FFFFFFF);
}
/**
 * get-guid
 **/
export const guid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

//金额格式化展示
export const amount_format_show = (str) => {
  str = String(str)
  if (!str || str == '') str = '0.00'
  if (str.indexOf('.') != -1) {
    var spStr = str.split('.')
    if (spStr.length == 2 && spStr[1].length > 2) {
      str = spStr[0] + '.' + spStr[1].substring(0, 2)
    }
  }
  return money_format(str)
}


//取消下方对应金额格式化
export const re_money_format = (number) => {
  if (!number) {
    return '';
  }
  number = String(number)
  return parseFloat(number.replace(/[^\d\.-]/g, "")).toFixed(2)
}

//小数变分数（元-》分）
export const value_to_points = (number) => {
  var m = re_money_format(number)
  m = String(m)
  if (m.indexOf('.') != -1) {
    // 如有小数位没有两位，需要补全
    if (m.split('.')[1].length < 2) {
      for (let i = 0; i < 2 - m.split('.')[1].length; i++) {
        m.split('.')[1] += '0'
      }
    }
    var r = m.split('.')[0] + m.split('.')[1]
    return Number(r)
  } else {
    return Number(String(m) + '00')
  }
}
// 分变元
export const amount_format_yuan = (number, isFormateYuan = true) => {
  if (number === '') {
    return ''
  }
  let num = Number(number)
  if (num === num) {
    if (isFormateYuan) {
      num = num / 100
    }
    return amount_format_show(num)
  } else {
    return ''
  }
}
// 利率
export const format_rate = (number) => {
  if (number === '') {
    return ''
  }
  let num = Number(number)
  if (num === num) {
    return num / 10000
  } else {
    return ''
  }
}
//金额格式化
export const money_format = (number) => {
  return number_format(number, 2, '.', ',')
}

// 执行利率
export const amount_format_rate = (number) => {
  let num = Number(number)
  if (num === num) {
    return (num / 10000).toFixed(2)
    // return String(num).replace(/(\d+)(\d{3})/,'$1')
  } else {
    return ''
  }
}

// 执行利率
export const reset_format_rate = (number) => {
  let num = Number(number)
  if (num === num) {
    // return amount_format_show(num / 1000)
    return (num * 10000).toFixed(0)
  } else {
    return ''
  }
}
//通用格式化
/*
 　　 * 参数说明：
 　　 * number：要格式化的数字
 　　 * decimals：保留几位小数
 　　 * dec_point：小数点符号
 　　 * thousands_sep：千分位符号
 　　 * */
export const number_format = (number, decimals, kdec_point, thousands_sep) => {
  number = (number + '').replace(/[^0-9+-Ee.]/g, '');
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 2 : Math.abs(decimals),
    sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
    dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
    s = '',
    toFixedFix = function (n, prec) {
      var k;
      k = n.toFixed(prec)
      return k + '';
      // var k = Math.pow(10, prec);
      // // var k = prec
      // return '' + Math.ceil(n * k) / k;
    };

  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
  var re = /(-?\d+)(\d{3})/;
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, "$1" + sep + "$2");
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
}


/**
 * 比较对象是否一样（包括value）
 */
export const objDefEquire = (a, b) => {
  if (a && b) {
    for (var key in a) {
      if (b.hasOwnProperty(key)) {
        if (b[key] != a[key] && key != 'dftId') {
          return {key: key, result: false}
        }
      } else {
        return {key: key, result: false}
      }
    }
    return {key: '', result: true}
  } else {
    console.log('throw-error', '')
    return {key: 'throw-error', result: false}
  }
}

/**
 * 禁用Backspace网页退回
 */
export const disabledBackSpace = () => {
  return (function () {
    window.history.forward(1);
    history.pushState(null, null, document.URL);
    if (window.history && window.history.pushState) {
      $(window).on('popstate', function () {
        // window.history.pushState('forward', null, '');
        window.history.forward(1);
      });
    }
    //
    // window.history.pushState('forward', null, '');
    window.history.forward(1);
  })()
}


/**
 * 根据value获取key
 * @param obj
 * @param value
 * @param compare
 * @return {*}
 */
export const findObjKey = (obj, value, compare = (a, b) => a === b) => {
  return Object.keys(obj).find(k => compare(obj[k], value))
}


/**
 * 判断空
 * @param {*} str
 */
export function isEmpty(str, defaultValue) {
  if (!defaultValue) {
    defaultValue = ''
  }
  return str ? str : defaultValue
}


export const fileDateFormat = (date) => {
  if (!date) return '-'
  if (date == '-' || date == '') return '-'
  var dateTime = new Date()
  dateTime.setTime(date)
  var Y = dateTime.getFullYear();
  var M = dateTime.getMonth() + 1;
  M = M < 10 ? '0' + M : M;// 不够两位补充0
  var D = dateTime.getDate();
  D = D < 10 ? '0' + D : D;
  var H = dateTime.getHours();
  H = H < 10 ? '0' + H : H;
  var Mi = dateTime.getMinutes();
  Mi = Mi < 10 ? '0' + Mi : Mi;
  // var S = Date.getSeconds();
  // S = S < 10 ? '0' + S : S;
  return Y + '-' + M + '-' + D + ' ' + H + ':' + Mi;
}

export const dateFormat = (fmt) => {
  let date = new Date()
  var o = {
    "M+": date.getMonth() + 1, //月份
    "d+": date.getDate(), //日
    "h+": date.getHours(), //小时
    "m+": date.getMinutes(), //分
    "s+": date.getSeconds(), //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    "S": date.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (let k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

/**
 * @param {date} 标准时间格式:Fri Nov 17 2017 09:26:23 GMT+0800 (中国标准时间)
 * @param {type} 类型
 *   type == 1 ---> "yyyy-mm-dd hh:MM:ss.fff"
 *   type == 2 ---> "yyyymmddhhMMss"
 *   type == '' ---> "yyyy-mm-dd hh:MM:ss"
 */
export const formatDate = (date, type) => {
  if (!date) {
    return ''
  }
  let year = date.getFullYear();//年
  let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;//月
  let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();//日
  let hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();//时
  let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();//分
  let seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();//秒
  let milliseconds = date.getMilliseconds() < 10 ? "0" + date.getMilliseconds() : date.getMilliseconds() //毫秒
  if (type == 1) {
    return year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds + "." + milliseconds;
  } else if (type == 2) {
    return year + "" + month + "" + day + "" + hour + "" + minutes + "" + seconds;
  } else if (type == 3) {
    return year + "-" + month + "-" + day;
  } else {
    return year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds;
  }
}

export const backToTop = () => {
  const cubic = value => Math.pow(value, 3);
  const easeInOutCubic = value => value < 0.5
    ? cubic(value * 2) / 2
    : 1 - cubic((1 - value) * 2) / 2;

  const el = document.documentElement;
  const beginTime = Date.now();
  const beginValue = el.scrollTop;
  const rAF = window.requestAnimationFrame || (func => setTimeout(func, 16));
  const frameFunc = () => {
    const progress = (Date.now() - beginTime) / 500;
    if (progress < 1) {
      el.scrollTop = beginValue * (1 - easeInOutCubic(progress));
      rAF(frameFunc);
    } else {
      el.scrollTop = 0;
    }
  };
  rAF(frameFunc);
}


export const asyncLoadScript = (src) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.onload = resolve
    script.onerror = reject
    document.head.appendChild(script)
  })
}

export async function loadScriptList(srcList, retryCount = 3, retryDelay = 1000, immediateRetry = true) {
  if (!srcList || srcList.length === 0) {
    throw new Error('请确认加载资源存在')
  }

  const resourceList = srcList.map(src => ({ src, loadStatus: false, count: 0 }))

  async function load(target) {
    try {
      await asyncLoadScript(target.src)
      target.loadStatus = true
      return target
    } catch (error) {
      target.loadStatus = false
      target.count++
      if (target.count > retryCount) {
        throw new Error(`加载资源失败:\n${target.src}`)
      }
      if (immediateRetry) {
        return load(target)
      } else {
        await new Promise(resolve => setTimeout(resolve, retryDelay))
        return load(target)
      }
    }
  }

  const results = await Promise.all(resourceList.map(load))
  const failedResults = results.filter(result => result.status === 'rejected').map(result => result.reason)
  if (failedResults.length > 0) {
    throw new Error('加载资源失败')
  } else {
    return results.map(result => result.value)
  }
}

/**
 * 秒转分
 * @param s
 * @return {string}
 */
export const s_to_hs = (s) => {
  //计算分钟
  //算法：将秒数除以60，然后下舍入，既得到分钟数
  var h;
  h = Math.floor(s / 60);
  //计算秒
  //算法：取得秒%60的余数，既得到秒数
  s = s % 60;
  //将变量转换为字符串
  h += '';
  s += '';
  //如果只有一位数，前面增加一个0
  h = (h.length == 1) ? '0' + h : h;
  s = (s.length == 1) ? '0' + s : s;
  return h + ':' + s;
}
/**
 * 计算百分比
 * @param num 分子
 * @param total 分母
 * @return {number} 返回百分比
 */
export const percentage = (num, total) => {
  if (!num || !total) {
    return 0
  }
  let res = Math.round(num / total * 10000) / 100
  return Math.round(res)
}


/**
 * 判断是否闰年
 */
export function isLeapYear(date) {
  if (!date) {
    date = ''
  }
  let day = new Date(date)
  let YY = day.getFullYear()
  // let MM = day.getMonth() + 1
  // let DD = day.getDate()
  let daycount = new Date(YY, 2, 0).getDate()
  if (daycount == 28) {
    return false
  } else {
    return true
  }
}


// 金额格式化
export function formatterMoney(val) {
  val = String(val);
  return val.toString().replace(/\d+/, function (n) { // 先提取整数部分
    return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
      return $1 + ",";
    });
  })
}

// 数字格式化
export function formatterNum(val) {
  val = String(val);
  val = val.replace(/。/g, "."); //替换。为.
  val = val.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
  val = val.replace(/^\./g, ""); //验证第一个字符是数字
  val = val.replace(/\.{2,}/g, "."); //只保留第一个, 清除多余的
  val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
  val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
  return val
}

export function computedTime(repayTotalStage, repayPerTime, repayFirstFinishTime) {
  let startTime = new Date(repayFirstFinishTime)
  if (!repayPerTime || !startTime || !repayTotalStage) {
    return
  }
  for (let i = 0; i < repayTotalStage; i++) {
    // 当前时间的年月
    let YY = startTime.getFullYear()
    let MM = startTime.getMonth() + 1
    // 往后加一个月
    MM++;
    // 跨年 ，年份+1，月份变1
    if (MM == 13) {
      YY++;
      MM = 1
    }
    let day = new Date(YY, MM, 0).getDate()
    if (day < repayPerTime) {
      startTime = new Date(YY, MM - 1, day)
    } else {
      startTime = new Date(YY, MM - 1, repayPerTime)
    }
  }
  return formatDate(startTime, 3)
}

/****************************************解决JS浮点数(小数)计算加减乘除的BUG    Start****************************************/

/**
 ** 加法函数，用来得到精确的加法结果
 ** 说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
 ** 调用：accAdd(arg1,arg2)
 ** 返回值：arg1加上arg2的精确结果
 **/
export function accAdd(arg1, arg2) {
  if (isNaN(arg1)) {
    arg1 = 0;
  }
  if (isNaN(arg2)) {
    arg2 = 0;
  }
  arg1 = Number(arg1);
  arg2 = Number(arg2);
  var r1, r2, m, c;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  c = Math.abs(r1 - r2);
  m = Math.pow(10, Math.max(r1, r2));
  if (c > 0) {
    var cm = Math.pow(10, c);
    if (r1 > r2) {
      arg1 = Number(arg1.toString().replace(".", ""));
      arg2 = Number(arg2.toString().replace(".", "")) * cm;
    } else {
      arg1 = Number(arg1.toString().replace(".", "")) * cm;
      arg2 = Number(arg2.toString().replace(".", ""));
    }
  } else {
    arg1 = Number(arg1.toString().replace(".", ""));
    arg2 = Number(arg2.toString().replace(".", ""));
  }
  return (arg1 + arg2) / m;
}

/**
 ** 减法函数，用来得到精确的减法结果
 ** 说明：javascript的减法结果会有误差，在两个浮点数相减的时候会比较明显。这个函数返回较为精确的减法结果。
 ** 调用：accSub(arg1,arg2)
 ** 返回值：arg1加上arg2的精确结果
 **/
export function accSub(arg1, arg2) {
  if (isNaN(arg1)) {
    arg1 = 0;
  }
  if (isNaN(arg2)) {
    arg2 = 0;
  }
  arg1 = Number(arg1);
  arg2 = Number(arg2);

  var r1, r2, m, n;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2)); //last modify by deeka //动态控制精度长度
  n = (r1 >= r2) ? r1 : r2;
  return ((arg1 * m - arg2 * m) / m).toFixed(n);
}

/**
 ** 乘法函数，用来得到精确的乘法结果
 ** 说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
 ** 调用：accMul(arg1,arg2)
 ** 返回值：arg1乘以 arg2的精确结果
 **/
export function accMul(arg1, arg2) {
  if (isNaN(arg1)) {
    arg1 = 0;
  }
  if (isNaN(arg2)) {
    arg2 = 0;
  }
  arg1 = Number(arg1);
  arg2 = Number(arg2);

  var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
  try {
    m += s1.split(".")[1].length;
  } catch (e) {
  }
  try {
    m += s2.split(".")[1].length;
  } catch (e) {
  }

  return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
}

// 校验密码强度
export const checkPassWord = (value, validLength = true) => {
  // 密码长度8-20，必须包含大写字母、小写字母、数字、特殊字符三类的组合
  // 0： 表示第一个级别 1：表示第二个级别 2：表示第三个级别
  // 3： 表示第四个级别 4：表示第五个级别
  var modes = 0;
  if (validLength && value.length < 6) {// 最初级别
    return modes;
  }
  if (/\d/.test(value)) {// 如果用户输入的密码 包含了数字
    modes++;
  }
  if (/[a-zA-Z]/.test(value)) {// 如果用户输入的密码 包含了小写的a到z
    modes++;
  }
  if (/\W/.test(value)) {// 如果是非数字 字母 下划线 [^A-Za-z0-9_]
    modes++;
  }
  // if (/[A-Z]/.test(value)) {// 如果用户输入的密码 包含了大写的A到Z
  //     modes++;
  // }

  return modes;
}


export const fileNameSuffix = (name) => {
  if (!name) return ''
  let index = name.lastIndexOf('.')
  return name.substr(index + 1).toLowerCase()
}

// 数字整数格式化
export function formatterInteger(val, places = 2) {
  val = String(val);
  val = val.replace(/[^\d]/g, ""); //清除"数字"以外的字符
  return val
}

// 身份证号码的校验
export function createdIdCardValid(tip = '') {
  return {
    type: 'string',
    message: tip + '证件号码格式不正确',
    validator: (rule, value, callback) => {
      let result = validConst.idCard(value)
      if (value.length > 0 && !result) {
        callback(new Error(tip + '证件号码格式不正确'))
      } else {
        callback()
      }
      return result
    }
  }
}

export function checkIDCard(id) {
  // 1 "验证通过!", 0 //校验不通过 // id为身份证号码
  let format = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/;
  //号码规则校验
  if(!format.test(id)){
    return false
  }
  //区位码校验
  //出生年月日校验   前正则限制起始年份为1900;
  let year = id.substr(6,4),//身份证年
    month = id.substr(10,2),//身份证月
    date = id.substr(12,2),//身份证日
    time = Date.parse(month+'-'+date+'-'+year),//身份证日期时间戳date
    now_time = Date.parse(new Date()),//当前时间戳
    dates = (new Date(year,month,0)).getDate();//身份证当月天数
  if(time>now_time||date>dates){
    return false
  }
  //校验码判断
  let c = new Array(7,9,10,5,8,4,2,1,6,3,7,9,10,5,8,4,2);   //系数
  let b = new Array('1','0','X','9','8','7','6','5','4','3','2');  //校验码对照表
  let id_array = id.split("");
  let sum = 0;
  for(let k=0;k<17;k++){
    sum+=parseInt(id_array[k])*parseInt(c[k]);
  }
  if(id_array[17].toUpperCase() != b[sum%11].toUpperCase()){
    return false
  }
  return true
}

export function getSex(id) {
  if (id.substr(16, 1) % 2 == 1) {
    return '1'
  } else {
    return '2'
  }
}

export function getAge(strBirthday) {
  let org_birthday = strBirthday.substring(6, 14);
  let birthday = org_birthday.substring(0, 4) + "-" + org_birthday.substring(4, 6) + "-" + org_birthday.substring(6, 8);
  let birthdays = new Date(birthday.replace(/-/g, "/"));
  let d = new Date();
  let age = d.getFullYear() - birthdays.getFullYear() - (d.getMonth() < birthdays.getMonth() || (d.getMonth() == birthdays.getMonth() && d.getDate() < birthdays.getDate()) ? 1 : 0);
  return age
}
export function getBirthday(id, split = '-'){
  id = id.replace(/\s*/g, '')
  let tmpStr = ''
  if (id.length === 15) {
    tmpStr = id.substring(6, 12)
    tmpStr = '19' + tmpStr
    tmpStr = tmpStr.substring(0, 4) + split + tmpStr.substring(4, 6) + split + tmpStr.substring(6)
  } else if (id.length === 18) {
    tmpStr = id.substring(6, 14)
    tmpStr = tmpStr.substring(0, 4) + split + tmpStr.substring(4, 6) + split + tmpStr.substring(6)
  }
  return tmpStr
}

export const checkSystemParams = (system, checkParam) => {
  if (system && typeof system == 'string' && checkParam) {
    return system.indexOf(checkParam) != -1
  } else {
    return false
  }
}

// 删除url中某个参数
export function funcUrlDel(name) {
  let loca = window.location;
  let baseUrl = loca.origin + loca.pathname + "?";
  let query = loca.search.substr(1);
  if (query.indexOf(name) > -1) {
    let obj = {}
    let arr = query.split("&");
    for (let i = 0; i < arr.length; i++) {
      arr[i] = arr[i].split("=");
      obj[arr[i][0]] = arr[i][1];
    }
    ;
    delete obj[name];
    let url = baseUrl + JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g, "&");
    return url
  };
}


/**
 * @param {Function} fn 目标函数
 * @param {Number} time 延迟执行毫秒数
 * @param {Boolean} immediate true - 立即执行 false - 延迟执行
 * @description 防抖函数
 */
export function debounce(fn, time = 1000, immediate = true) {
  let timer
  return function() {
    const that = this
    const args = arguments

    if (timer) clearTimeout(timer)
    if (immediate) {
      const callNow = !timer
      timer = setTimeout(() => {
        timer = null
      }, time)
      if (callNow) {
        fn.apply(that, args)
      }
    } else {
      timer = setTimeout(() => {
        fn.apply(that, args)
      }, time)
    }
  }
}
// 格式化数据
export function formatConfig(data, _this) {
  data = data || {}
  Object.keys(data).forEach(key => {
    if (key !== 'actId') {
      const extendFields = data[key].extendFields;
      if (extendFields) {
        Object.keys(extendFields).forEach(item => {
          _this.$set(data[key], `extendFields&${item}`, extendFields[item]);
        });
      }
    }
  });
  data.iouInfos = data.iouInfo
  return data;
}

// 下载文件
export function downloadFile(url) {
  // 创建一个隐藏的链接
  const link = document.createElement('a');
  link.style.display = 'none';
  link.href = url;
  link.setAttribute('download', '');

  // 将链接添加到 DOM 中
  document.body.appendChild(link);
  sessionStorage.setItem('downloadFile', 'true')
  // 触发链接的点击事件
  link.click();
  // 移除链接
  document.body.removeChild(link);
  setTimeout(()=>{
    sessionStorage.removeItem('downloadFile')
  }, 100)
}

// 电话隐藏中间四位
export function formatPhone(value) {
  if (!value) {
    return '';
  }
  return value.replace(/(\d{3}-?)\d*(\d{4})/, '$1****$2');
}
export function hasVideoList() {
  let videoListStr = localStorage.getItem('videoList') || '[]';
  return JSON.parse(videoListStr).length > 0;
}

export function encryptionPhone(value) {
  if (!value) {
    return '';
  }
  if(validConst.FixedTelReg.test(value)){
    return value
  } else {
    const specialChars = ['-','-','－','）',')',' '];
    let index = -1;

    // 查找特殊字符的位置
    for (let char of specialChars) {
      index = Math.max(index, value.indexOf(char));
    }
    let prefix = value.slice(0, index+1)
    let phone = value.slice(index + 1, value.length)
    if(phone.length <= 7){
      return prefix + phone
    } else {
      let arr = new Array(phone.length - 7)
      let hideChar = arr.fill('*')
        .join('')
      let result = prefix + phone.slice(0, 3) + hideChar + phone.slice(phone.length - 4, phone.length)
      return result
    }
  }
}
export function encryptionIdNumber(idNo) {
  if (!idNo) {
    return '';
  }
  let start, end;

  // 18位前3后4
  if (idNo.length === 18) {
    start = 3;
    end = 14;
  }
  // 大于4位，保留前2后2
  else if (idNo.length > 4) {
    start = 2;
    end = idNo.length - 2;
  }
  // 3或4位，保留后2
  else if (idNo.length === 3) {
    start = 0;
    end = 1;
  }
  // 2位，保留后1
  else if (idNo.length === 4) {
    start = 0;
    end = 2;
  }
  // 2位，保留后1
  else if (idNo.length === 2) {
    start = 0;
    end = 1;
  }
  // 1位直接展示
  else {
    return idNo;
  }

  // 使用substring进行脱敏
  const hideChar = '*';
  let result = idNo.substring(0, start) + idNo.substring(start, end).split('').map(() => hideChar).join('') + idNo.substring(end);
  return result

}

export function highlightText(text, keyword) {
  if (!keyword || !text) {
    return text;
  }
  // 转义关键词中的特殊字符，防止正则表达式出错
  const escapedKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  // 构建正则表达式，匹配未被 <mark> 包裹的关键词
  const regex = new RegExp(`(?<!<mark>)(${escapedKeyword})(?!<\/mark>)`, 'gi');
  return text.replace(regex, '<mark>$1</mark>');
}

